import React, { useEffect, useState } from "react";
// import * as XLSX from "xlsx";
import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";
import { Link } from "react-router-dom";
import { Eye, Copy } from "react-feather";
import { useSelector } from "react-redux";
import Table2 from '../../core/pagination/datatable2'
import ViewCustomerOrders from "../../core/modals/usermanagement/viewcustomerorders";
import axios from 'axios';
import { Modal, message } from "antd";
import { getBalanceMessage2 } from "../../plugins/helper";
import { APIgetPublicUsers } from "../../api/settings.ts";
import { dateFormatter2, getCurrencySymbol } from "../../plugins/helper";

// import { set } from "date-fns";
const Customers = () => {
  const [users, setUsers] = useState([]);
  const [allUsers, setAllUsers] = useState([]);
  const [orderList, setOrderList] = useState([]);
  const [actualOrderList, setActualOrderList] = useState([]);
  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");

  const l = useSelector((state) => state.language || "en");
  const t = useSelector((state) => state.translation || "en");
  
  async function fetchOrders(allUsers) {
    try {
      const storeIds = localStorage.getItem('storeIds');
      const result = await axios.get("gettenantorders/", {
          params: {
            storeIds: storeIds, // Add query parameters here
            sortDesc: "createdAt"
          },
        });
        const record  =  result.data.orders.filter((order) => order.transitStatus && order.transitStatus.toLowerCase() !== "cancelled" && order.transitStatus.toLowerCase() !== "rejected");
        setActualOrderList(record);
      setOrderList(record);
      
      const summarized = record.map(order => {
      const paidAmounts = order.manualPayments?.reduce((sum, p) => sum + (p.amount || 0), 0) || 0;
      const additionalPayments = order.manualPayments?.reduce((sum, p) => sum + (p.addiPayment || 0), 0) || 0;
      const balance = order.grossTotal - paidAmounts;
      return {
        userId: order.shippingAddress.email,//order.userId,
        grossTotal: order.grossTotal,
        grossCount: order.grossCount,
        paidAmounts,
        additionalPayments,
        balance,
        departureDate: order.departureDate ? dateFormatter2(order.departureDate) : "",
      };
    });

  const aggregated = summarized.reduce((acc, curr) => {
    if (!acc[curr.userId]) {
      acc[curr.userId] = { ...curr };
    } else {
      acc[curr.userId].grossTotal += curr.grossTotal;
      acc[curr.userId].grossCount += curr.grossCount;
      acc[curr.userId].paidAmounts += curr.paidAmounts;
      acc[curr.userId].additionalPayments += curr.additionalPayments;
      acc[curr.userId].balance += curr.balance;
    }
    return acc;
  }, {});

    // Step 3: Convert aggregated object to array
    const result2 = Object.values(aggregated);
    const resultMap = Object.fromEntries(result2.map(r => [r.userId, r]));
    // Merge data into users
    
    const enrichedUsers = allUsers.map(user => {
      const stats = resultMap[user.email] || {
        grossTotal: 0,
        grossCount: 0,
        paidAmounts: 0,
        additionalPayments: 0,
        balance: 0
      };

      return {
        ...user,
        ...stats
      };
    });


    const sortedUsers = enrichedUsers.sort((a, b) => b.balance - a.balance);

    setUsers(sortedUsers);
    setAllUsers(sortedUsers);
    } catch (error) {
        console.error("Error fetching orders:", error);
    }
  }
//orderList
const filterOrders = () => {
  //allUsers,orderList
  if (!fromDate && !toDate) {
    setUsers(allUsers);
    return;
  }
  console.log("Filtering allUsers:", allUsers);
  //users

  const fromTimestamp = fromDate ? new Date(fromDate).getTime() : 0;
  const toTimestamp = toDate ? new Date(toDate).getTime() + 86400000 - 1 : Infinity; // End of day

   try {

    // orderList
    console.log("before Filtering orderList:", actualOrderList);
      const filteredOrders = actualOrderList?.filter(
      (order) =>
        order.createdAt >= fromTimestamp &&
        order.createdAt <= toTimestamp
    );
    console.log("after Filtering orderList:", filteredOrders);
      setOrderList(filteredOrders);
      
      const summarized = filteredOrders?.map(order => {
        const paidAmounts = order.manualPayments?.reduce((sum, p) => sum + (p.amount || 0), 0) || 0;
        const additionalPayments = order.manualPayments?.reduce((sum, p) => sum + (p.addiPayment || 0), 0) || 0;
        const balance = order.grossTotal - paidAmounts;
        return {
          userId: order.shippingAddress.email,//order.userId,
          grossTotal: order.grossTotal,
          grossCount: order.grossCount,
          paidAmounts,
          additionalPayments,
          balance,
          departureDate: order.departureDate ? dateFormatter2(order.departureDate) : "",
        };
      });

  const aggregated = summarized?.reduce((acc, curr) => {
    if (!acc[curr.userId]) {
      acc[curr.userId] = { ...curr };
    } else {
      acc[curr.userId].grossTotal += curr.grossTotal;
      acc[curr.userId].grossCount += curr.grossCount;
      acc[curr.userId].paidAmounts += curr.paidAmounts;
      acc[curr.userId].additionalPayments += curr.additionalPayments;
      acc[curr.userId].balance += curr.balance;
    }
    return acc;
  }, {});

    // Step 3: Convert aggregated object to array
    const result2 = Object.values(aggregated);
    const resultMap = Object.fromEntries(result2?.map(r => [r.userId, r]));
    // Merge data into users

    const enrichedUsers = users.map(user => {
      const stats = resultMap[user.email] || {
        grossTotal: 0,
        grossCount: 0,
        paidAmounts: 0,
        additionalPayments: 0,
        balance: 0
      };

      return {
        ...user,
        ...stats
      };
    });


    const sortedUsers = enrichedUsers.sort((a, b) => b.balance - a.balance);

    setUsers(sortedUsers);
    setAllUsers(sortedUsers);
    } catch (error) {
        console.error("Error fetching orders:", error);
    }

// fetchOrders(custData,fromTimestamp, toTimestamp);
//   const filtered = allUsers.filter((user) => {
//     const userOrders = orderList.filter(
//       (order) =>
//         order.shippingAddress?.email === user.email &&
//         order.createdAt >= fromTimestamp &&
//         order.createdAt <= toTimestamp
//     );

//     return userOrders.length > 0;
//   });

//   // Keep user-level stats from existing state
//   const updatedUsers = filtered.map(fUser => {
//     return allUsers.find(u => u.email === fUser.email);
//   });

// //  setFilteredUserRecord(updatedUsers);
//   setUsers(updatedUsers);
};



  useEffect(() => {
    try {
      let filteredCustomers = [...allUsers]; 
      
      if (searchTerm && searchTerm !== "") {
        filteredCustomers = filteredCustomers.filter((customer) => {
          // If searchTerm is not a number, filter by name, category, and other conditions
          return (
            customer.fullName?.toLowerCase().includes(searchTerm.toLowerCase()) ||
            customer.email?.toLowerCase().includes(searchTerm.toLowerCase())
          );
        });
      }
       setUsers(filteredCustomers);
    }
    catch (error) {
      console.error("Error filtering customers:", error);
      message.error("Failed to filter customers. Please try again later.");
      setUsers([]);
    }
     
    }, [searchTerm]);

  useEffect(() => {
    async function fetchData() {
      try
      {
       const result = await APIgetPublicUsers({});
        if(result?.response)
        {

          const custData = result?.response.map((item) => {
                  const { fullName, firstName, lastName } = item.profile;
                  return {
                    ...item,
                    fullName: !fullName ? firstName +" "+(lastName?lastName:"") : fullName,
                  };
                });

            await fetchOrders(custData);
        }
      } catch (error) {
         await fetchOrders([]);
        console.error("Error fetching users:", error);
        message.error("Failed to fetch customers. Please try again later.");
      }
    }
    fetchData();
  
  }, [])
//  const handleDownloadExcel = (user) => {
//   try {
//     const exportData = [{
//       Name: user.fullName,
//       Email: user.email,
//       "# of Cars": user.grossCount,
//       "Total Amount": user.grossTotal,
//       "Amount Paid": user.paidAmounts,
//       "Balance": user.balance,
//       "Paid %": user.grossTotal > 0 ? ((user.paidAmounts / user.grossTotal) * 100).toFixed(0) + "%" : "0%",
//       "Received Misc": user.additionalPayments
//     }];

//     const worksheet = XLSX.utils.json_to_sheet(exportData);
//     const workbook = XLSX.utils.book_new();
//     XLSX.utils.book_append_sheet(workbook, worksheet, "Customer");

//     const fileName = `${user.fullName || "Customer"}_Report.xlsx`;
//     XLSX.writeFile(workbook, fileName);
//   } catch (error) {
//     console.error("Error downloading individual Excel:", error);
//     message.error("Failed to download Excel for this customer.");
//   }
// };

const handleDownloadPDF = (user) => {
  try {
    // Create a new PDF document
    const doc = new jsPDF();

    // Add title
    doc.setFontSize(18);
    doc.text(`${user.fullName || "Customer"} Report`, 14, 22);

    // Prepare data for the table
    const data = [
      ["Name", user.fullName || "-"],
      ["Email", user.email || "-"],
      ["# of Cars", user.grossCount || "0"],
      ["Total Amount", user.grossTotal ? `$${user.grossTotal.toFixed(2)}` : "$0.00"],
      ["Amount Paid", user.paidAmounts ? `$${user.paidAmounts.toFixed(2)}` : "$0.00"],
      ["Balance", user.balance ? `$${user.balance.toFixed(2)}` : "$0.00"],
      ["Paid %", user.grossTotal > 0 ? `${((user.paidAmounts / user.grossTotal) * 100).toFixed(0)}%` : "0%"],
      ["Received Misc", user.additionalPayments ? `$${user.additionalPayments.toFixed(2)}` : "$0.00"]
    ];

    // Add table to PDF using autoTable
    autoTable(doc, {
      startY: 30,
      head: [['Field', 'Value']],
      body: data,
      theme: 'grid',
      headStyles: {
        fillColor: [41, 128, 185],
        textColor: 255,
        fontStyle: 'bold'
      },
      styles: {
        cellPadding: 3,
        fontSize: 10
      },
      columnStyles: {
        0: { cellWidth: 50, fontStyle: 'bold' },
        1: { cellWidth: 'auto' }
      }
    });

    // Save the PDF
    const fileName = `${user.fullName || "Customer"}_Report.pdf`;
    doc.save(fileName);
  } catch (error) {
    console.error("Error downloading individual PDF:", error);
    // message.error("Failed to download PDF for this customer.");
    alert("Failed to download PDF for this customer."); // Fallback if message is not available
  }
};

//  const handleDownloadExcelDetails = (user) => {
//   try {
//     const filteredOrders = orderList.filter(order => order.shippingAddress?.email === user.email);
//     const summarized = filteredOrders.map(order => {
//             const paidAmounts = order.manualPayments?.reduce((sum, p) => sum + (p.amount || 0), 0) || 0;
//             const additionalPayments = order.manualPayments?.reduce((sum, p) => sum + (p.addiPayment || 0), 0) || 0;
//             const balance = order.grossTotal - paidAmounts;
//             return {
//                 fullName: order.shippingAddress.name,
//                 userId: order.shippingAddress.email,
//                 grossTotal: order.grossTotal,
//                 grossCount: order.grossCount,
//                 chassisNumbers: order.chassisNumbers.join(",") || [],
//                 productName: order.products.map(p => p.name).join(", ") || "",
//                 paidAmounts,
//                 additionalPayments,
//                 balance,
//                 departureDate: order.departureDate ? dateFormatter2(order.departureDate) : "",
//             };
//         });
//     const exportData = summarized.map(user => ({
//         "Customer Name": user.fullName,
//         "Vehicle Details": user.productName,
//         "Departure Date": user.departureDate,
//         "Chassis Numbers": user.chassisNumbers,
//         "Received %": user.grossTotal > 0 ? ((user.paidAmounts / user.grossTotal) * 100).toFixed(0) + "%" : "0%",
//         "Sold Price": user.grossTotal,
//         "Total Received": user.paidAmounts,
//         "Balance ": user.balance, 
//         "Received Misc": user.additionalPayments
//     }));

//      // ➕ Add Totals Row
//     const totals = summarized.reduce(
//       (acc, curr) => {
//         acc.grossTotal += curr.grossTotal || 0;
//         acc.paidAmounts += curr.paidAmounts || 0;
//         acc.additionalPayments += curr.additionalPayments || 0;
//         acc.balance += curr.balance || 0;
//         return acc;
//       },
//       { grossTotal: 0, paidAmounts: 0, additionalPayments: 0, balance: 0 }
//     );

//     exportData.push({
//       "Customer Name": "Total",
//       "Vehicle Details": "",
//       "Departure Date": "",
//       "Chassis Numbers": "",
//       "Received %": "",
//       "Sold Price": totals.grossTotal,
//       "Total Received": totals.paidAmounts,
//       "Balance ": totals.balance,
//       "Received Misc": totals.additionalPayments
//     });



//     const worksheet = XLSX.utils.json_to_sheet(exportData);
//     const workbook = XLSX.utils.book_new();
//     XLSX.utils.book_append_sheet(workbook, worksheet, "Customer");

//     const fileName = `${user.fullName || "Customer"}_Report.xlsx`;
//     XLSX.writeFile(workbook, fileName);
//   } catch (error) {
//     console.error("Error downloading individual Excel:", error);
//     message.error("Failed to download Excel for this customer.");
//   }
// };


  // Helper function

const handleDownloadPDFDetails = (user) => {
  try {
    const doc = new jsPDF();
    const filteredOrders = orderList.filter(order => order.shippingAddress?.email === user.email);
    
    // Process orders data (same as Excel version)
    const summarized = filteredOrders.map(order => {
      const paidAmounts = order.manualPayments?.reduce((sum, p) => sum + (p.amount || 0), 0) || 0;
      const additionalPayments = order.manualPayments?.reduce((sum, p) => sum + (p.addiPayment || 0), 0) || 0;
      const balance = order.grossTotal - paidAmounts;
      
      return {
        fullName: order.shippingAddress.name,
        userId: order.shippingAddress.email,
        grossTotal: order.grossTotal,
        grossCount: order.grossCount,
        chassisNumbers: order.chassisNumbers.join(",") || [],
        productName: order.products.map(p => p.name).join(", ") || "",
        paidAmounts,
        additionalPayments,
        balance,
        departureDate: order.departureDate ? dateFormatter2(order.departureDate) : "",
      };
    });

    // Calculate totals (same as Excel version)
    const totals = summarized.reduce(
      (acc, curr) => {
        acc.grossTotal += curr.grossTotal || 0;
        acc.paidAmounts += curr.paidAmounts || 0;
        acc.additionalPayments += curr.additionalPayments || 0;
        acc.balance += curr.balance || 0;
        return acc;
      },
      { grossTotal: 0, paidAmounts: 0, additionalPayments: 0, balance: 0 }
    );

    // Prepare data for the table
    const tableData = summarized.map(user => [
      user.fullName || "-",
      user.productName || "-",
      user.departureDate || "-",
      user.chassisNumbers || "-",
      user.grossTotal > 0 ? `${((user.paidAmounts / user.grossTotal) * 100).toFixed(0)}%` : "0%",
      `$${(user.grossTotal || 0).toFixed(2)}`,
      `$${(user.paidAmounts || 0).toFixed(2)}`,
      `$${(user.balance || 0).toFixed(2)}`,
      `$${(user.additionalPayments || 0).toFixed(2)}`
    ]);

    // Add totals row
    tableData.push([
      "TOTAL",
      "",
      "",
      "",
      "",
      `$${totals.grossTotal.toFixed(2)}`,
      `$${totals.paidAmounts.toFixed(2)}`,
      `$${totals.balance.toFixed(2)}`,
      `$${totals.additionalPayments.toFixed(2)}`
    ]);

    // Add title
    doc.setFontSize(16);
    doc.text(`${user.fullName || "Customer"} Detailed Report`, 14, 15);
    doc.setFontSize(10);
    doc.text(`Generated on: ${new Date().toLocaleDateString()}`, 14, 22);

    // Add main table
    autoTable(doc, {
      startY: 30,
      head: [
        [
          "Customer Name",
          "Vehicle Details",
          "Departure Date",
          "Chassis Numbers",
          "Received %",
          "Sold Price",
          "Total Received",
          "Balance",
          "Received Misc"
        ]
      ],
      body: tableData,
      theme: "grid",
      headStyles: {
        fillColor: [41, 128, 185],
        textColor: 255,
        fontStyle: "bold",
        fontSize: 9
      },
      bodyStyles: {
        fontSize: 8
      },
      columnStyles: {
        0: { cellWidth: 25 }, // Customer Name
        1: { cellWidth: 30 }, // Vehicle Details
        2: { cellWidth: 20 }, // Departure Date
        3: { cellWidth: 25 }, // Chassis Numbers
        4: { cellWidth: 15 }, // Received %
        5: { cellWidth: 20 }, // Sold Price
        6: { cellWidth: 20 }, // Total Received
        7: { cellWidth: 20 }, // Balance
        8: { cellWidth: 20 }  // Received Misc
      },
      styles: {
        overflow: "linebreak",
        cellPadding: 2,
        valign: "middle"
      },
      // didDrawPage: function (data) {
      //   // Footer
      //   doc.setFontSize(8);
      //   doc.setTextColor(100);
      //   doc.text(
      //     `Page ${data.pageCount}`,
      //     data.settings.margin.left,
      //     doc.internal.pageSize.height - 10
      //   );
      // }
    });

    
    // Save the PDF
    const fileName = `${user.fullName || "Customer"}_Detailed_Report.pdf`;
    doc.save(fileName);
  } catch (error) {
    console.error("Error downloading individual PDF:", error);
    message.error("Failed to download PDF for this customer.");
  }
};

  const columns = [
    {
      title: t?.[l]?.["name"] || "Name",
      dataIndex: "fullName", // can still be used for search/sort
      render: (_, record) => (
        <span>
          {record.fullName}
        </span>
      ),
    },   

    {
      title: t?.[l]?.["email"] || "Email",
      dataIndex: "email",
      // sorter: (a, b) => a.email.length - b.email.length,
    },

    {
      title: t?.[l]?.["#_of_cars"] || "# of Cars",
      dataIndex: "grossCount"
      
    },
    {
      title: t?.[l]?.["total_amount"] || "Total Amount",
      dataIndex: "grossTotal",
      render: (value) => `${getCurrencySymbol()}${(value || 0).toLocaleString()}`
      
    },

    {
      title: t?.[l]?.["amount_paid"] || "Amount Paid",
      dataIndex: "paidAmounts",
      render: (value) => `${getCurrencySymbol()}${(value || 0).toLocaleString()}`,
      // sorter: (a, b) => a.email.length - b.email.length,
    },
    {
      title: t?.[l]?.["balance"] || "Balance",
      dataIndex: "balance",
      render: (value) => `${getCurrencySymbol()}${(value || 0).toLocaleString()}`,
      // sorter: (a, b) => a.email.length - b.email.length,
    },
    {
        title: t[l]?.["paid_percentage"] || "Paid %",
        render: (_, record) => {
            const grossTotal = record.grossTotal || 0;
            const totalPaid = record.paidAmounts || 0;
            const percentage = grossTotal > 0 ? (totalPaid / grossTotal) * 100 : 0;
            return `${percentage.toFixed(0)}%`;
        }
    },
    {
      title: t?.[l]?.["recieved_misc"] || "Recieved Misc",
      dataIndex: "additionalPayments",
      render: (value) => `${getCurrencySymbol()}${(value || 0).toLocaleString()}`,
      // sorter: (a, b) => a.email.length - b.email.length,
    },
    
    {
      title: t?.[l]?.["action"] || "Action",
      dataIndex: "action",
      render: (text, record) => (
        <div className="action-table-data">
          <div className="edit-delete-action">
            <div className="input-block add-lists"></div>

            <Link className="me-2 p-2 hidden" to="#">
              <Eye className="feather-view" />
            </Link>
         
              <Link
                className="me-2 p-2"
                to="#"
                data-bs-toggle="modal"
                data-bs-target="#edit-units"
                onClick={() => setSelectedCustomer(record)}

              >
                <Eye className="feather-view" />
              </Link>
               {/* Copy Balance Icon */}
              <Link
                className="me-2 p-2"
                to="#"
                onClick={(e) => {
                  e.preventDefault();
                  const name = `${record.fullName || ""}`;
                  const totalBalance = (record.balance ?? 0).toLocaleString();
                 // const miscReceived = (record.miscReceived ?? 0).toLocaleString();
                  const filteredOrder =  orderList?.filter(item => item?.shippingAddress.email == record?.email);
                
                  const msg = getBalanceMessage2(t[l]?.["message_company"] || "Pak Nippon Corporation, Japan", name, filteredOrder, totalBalance);

                  
                  navigator.clipboard.writeText(msg).then(() => {
                    message.success("Message copied to clipboard!");
                    Modal.info({
                      title: "Message",
                      content: <pre style={{ whiteSpace: "pre-wrap" }}>{msg}</pre>,
                      okText: "Close",
                      okButtonProps: {
                        style: { backgroundColor: "#BC8F8F", borderColor: "#BC8F8F", color: "#fff" },
                      },
                    });
                  }).catch(() => {
                    message.error("Failed to copy message.");
                  });
                }}
              >
                <Copy className="feather-copy" />
              </Link>
            <Link
  className="me-2 p-2 text-success"
  to="#"
  onClick={(e) => {
    e.preventDefault();
    handleDownloadPDF(record);
  }}
  title="Download Current Summary"
>
  📄
</Link>

<Link
  className="me-2 p-2 text-primary"
  to="#"
  onClick={(e) => {
    e.preventDefault();
    handleDownloadPDFDetails(record);
  }}
  title="Download Detailed Report"
>
  📊
</Link>


            
            
          </div>
        </div>
      ),
      // sorter: (a, b) => a.createdby.length - b.createdby.length,
    },
  ];

  
  //Permissions
  const permissions = useSelector(state => state.permissions) || [];
  const roleTitle = useSelector(state => state.roleTitle) || [];
  const roleTitleAdmin = useSelector(state => state.roleTitleAdmin) || [];
  
  // Check permissions
  const canView = roleTitle === roleTitleAdmin || permissions.some(p => p.Module.toLowerCase() === 'suppliers' && p.Permission.toLowerCase() === 'view');

  if (!canView) {
      return ( 
      <div className={`${l === 'ar' ? 'page-wrapper-rtl' : 'page-wrapper'}`}><div className="content"><p>{t?.[l]?.["no_permission"] || "You do not have permission to view this page."}</p></div></div>
  )}

  return (
    <div className={`${l === 'ar' ? 'page-wrapper-rtl' : 'page-wrapper'}`}>
      <div className="content">
        <div className="page-header">
          <div className="add-item d-flex">
            <div className="page-title">
            <h4>{t[l]?.["customers_list"] || "Customers List"}</h4>
            <h6>{t[l]?.["manage_customers"] || "Manage Customers"}</h6>
            </div>
          </div>
          
       
        <div className="search-set d-flex" style={{ marginLeft: "auto" }}>
          <input
            type="date"
            className="form-control me-2"
            value={fromDate}
            onChange={(e) => setFromDate(e.target.value)}
          />
          <input
            type="date"
            className="form-control me-2"
            value={toDate}
            onChange={(e) => setToDate(e.target.value)}
          />
          <button className="btn btn-primary" onClick={() => filterOrders()}>
            {t?.[l]?.["filter"] || "Filter"}
          </button>
        </div>

           <div className="search-set" style={{marginLeft: "auto"}}>
            <div className="search-input">
                <input
                    type="text"
                    placeholder={t?.[l]?.["search"] || "Search"}
                    className="form-control"
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                />
                <span to="#" className="btn btn-searchset" style={{ paddingTop: "10px"}}>
                    <i className="feather-search" />
                </span>
            </div>
           
           
         </div>
        </div>
                                     
            
        {/* /product list */}
        <div className="card table-list-card">
          <div className="card-body">
            <div className="table-responsive">
              <Table2
                className="table datanew"
                columns={columns}
                dataSource={users}
                rowKey={(record) => record._id}
          
              />
            </div>
          </div>
        </div>
       
      </div>
      <ViewCustomerOrders customer={selectedCustomer} orderList={orderList}/>
    </div>
  );
};

export default Customers;
